export default __webpack_public_path__ + "static/media/Scenografia Africa 2.4040e07f.jpg";